<template>
  <v-navigation-drawer id="drawer" permanent absolute temporary>
    <v-list-item>
      <v-list-item-title>
        <h3>History</h3>
      </v-list-item-title>
      <v-list-item-action>
        <v-btn icon>
          <v-icon v-on:click="closeDrawer" color="grey lighten-1">{{mdiClose}}</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-divider></v-divider>

    <v-list>
      <p v-if="history === null">No round completed yet.</p>
      <v-list-item v-for="(item, itemId) in history" :key="itemId">
        <v-list-item-content>
          <v-list-item-title>Round {{ itemId + 1}}</v-list-item-title>
          <v-list-item-subtitle>
            <v-card class="d-flex pa-2" id="card" elevation="0">
              <v-img :key="idx" v-for="(card, idx) in item.results" :aspect-ratio="0.65" max-width="100px" v-bind:src="getCardImage(card, item.mode)" style="margin-left:5px"></v-img>
            </v-card>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mdiClose } from '@mdi/js'

  export default {
    data () {
      return {
        mdiClose
      }
    },
    props: {
      history: Array
    },
    methods: {
      closeDrawer: function() {
        this.$store.commit('disableDrawer')
      },
      getCardImage: function (name, mode) {
        return require('@/assets/cards/' + mode + '/' + name + '.png')
      }
    }
  }
</script>

<style scoped>
#drawer {
  width: 30%;
  min-width: 300px
}
</style>